module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-152x152-1c95a3c36159021280a13f4098a023f0.png";